<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-breakpoint="960"
    clipped
    :right="$vuetify.rtl"
    mini-variant-width="70"
    
    app
    id="main-sidebar"
  >
    <v-list dense nav>
      <!---User Area -->
      <v-list-item two-line class="px-0" v-if="User">
        <v-list-item-avatar style="border: 1px solid #FFF">
          <!-- <img :src="User.staff.profile_img" alt="user" /> -->
          <img :src="User.staff.profile_url" alt="user" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="grey--text text--darken-4" >{{ User.name }}</v-list-item-title>
          <v-list-item-subtitle class="caption grey--text text--darken-2 text-capitalize">{{ $store.state.User.staff.EngPosition }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!---User Area -->


      <!---Sidebar Items -->
      <div
        v-for="item in User.menu_items"
        :key="item.title"
      >
        <!-- single level menu items -->
        <!-- && (!item.permission || (User && UserCan && $can(item.permission)))  -->
        <v-list-item
          :to="item.to"
          v-if="(!item.items || item.items.length == 0) "
          active-class="grey"
          link
        >
          <v-list-item-icon>
            <v-icon color="grey darken-3">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="grey--text text--darken-3">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- 2 level menu items -->
        <!-- && (!item.permission || (User && UserCan && $can(item.permission))) -->
        <v-list-group
          v-if="item.items && item.items.length "
          active-class="grey--text text--darken-3"
          class="grey--text text--darken-3"
        >
          <template v-slot:prependIcon>
            <v-icon class="grey--text text--darken-3">{{ item.icon }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="grey--text text--darken-3">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:appendIcon>
            <v-icon class="grey--text text--darken-3">mdi-chevron-down</v-icon>
          </template>
          <v-divider style="border-color: #ccc;" />
          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.to"
            class="pl-10 grey--text text--darken-3"
            link
          >
            <!-- <v-list-item-icon>
              <v-icon class="grey--text text--darken-3">
                {{subItem.icon}}
              </v-icon>
            </v-list-item-icon> -->
            <v-list-item-content>
              <v-list-item-title>
                {{subItem.title}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-group>

      </div>

      <!-- <pre style="color:black;">{{User.menu_items}}</pre> -->
      
      <!-- <v-list-item active-class="grey" v-if="!User">
        <v-list-item-icon>
          <v-icon color="grey darken-3">mdi-login</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="grey--text text--darken-3">
            <a href="/api/login" style="text-decoration: none;" class="grey--text text--darken-3">Login</a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <!---Sidebar Items -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState} from 'vuex'

export default {
    name: "SideBar",
    data: () => ({
        designation: '{Designation}',
        selectedItem: 0,
        items: []
    }),
    computed: {
        ...mapState(["SidebarColor", "SidebarBg"]),
        Sidebar_drawer: {
            get() {
                return this.$store.state.Sidebar_drawer;
            },
            set(val) {
                this.$store.commit("SET_SIDEBAR_DRAWER", val)
            }
        }

    },

    watch: {
        "$vuetify.breakpoint.smAndDown" (val) {
            this.$emit("update:expandonHover", !val);
        }
    },
    

}
</script>

<style scoped>
/* div >>> .v-list a {
    text-decoration: none;
} */
  .v-list-item >>> .v-list-item__icon, .v-list-group >>> .v-list-item__icon {
    margin-right: 10px !important;
  }
</style>